import { useMemo } from 'react';
import { GridColumn } from 'src/components/GridWrapper';
import GLCodeDetailColumnCell from 'src/components/custom-cells/GLCodeDetailCell';
import GLCodeDetailHeaderCell from 'src/components/custom-cells/GLCodeDetailHeaderCell';
import { InvoiceContext } from 'src/sections/invoice_details/InvoiceDetailsContext';
import GlCodeAction from 'src/sections/invoice_details/glCodesColumns/GlCodeAction';
import GlCodesDiscount from 'src/sections/invoice_details/glCodesColumns/GlCodeDiscount';
import GlCodeDropDown from 'src/sections/invoice_details/glCodesColumns/GlCodeDropDown';
import GlCodeInfo from 'src/sections/invoice_details/glCodesColumns/GlCodeInfo';
import GlCodesShipping from 'src/sections/invoice_details/glCodesColumns/GlCodeShipping';
import GlCodeSubTotal from 'src/sections/invoice_details/glCodesColumns/GlCodeSubTotal';
import GlCodeTaxableAmount from 'src/sections/invoice_details/glCodesColumns/GlCodeTaxableAmount';
import GlCodesTaxes from 'src/sections/invoice_details/glCodesColumns/GlCodeTaxes';
import GlCodeTotal from 'src/sections/invoice_details/glCodesColumns/GlCodeTotal';
import GlCodesNotes from 'src/sections/invoice_details/glCodesColumns/GlCodesNotes';
import InvoiceBudgetPeriodWarning from 'src/sections/view_invoice_budget_period/custom_cells/InvoiceBudgetPeriodWarning';
import { InvoiceGlBreakoutItem } from 'src/services/useInvoiceGlBreakoutApi';
import { useContextSelector } from 'use-context-selector';

export const useInvoiceDetailsGLCodesColumns = () => {
  const isInvoiceMPA = useContextSelector(InvoiceContext, (value) => value.isInvoiceMPA);

  const invoiceDetailsGLCodesColumns: GridColumn<InvoiceGlBreakoutItem>[] = useMemo(() => [
    ...(isInvoiceMPA
      ? [
          {
            field: 'expanded',
            width: 45,
            component: GLCodeDetailColumnCell,
            menu: false,
            headerCell: GLCodeDetailHeaderCell,
          },
        ]
      : []),
    {
      field: 'errors',
      title: '',
      menu: false,
      component: GlCodeInfo,
      width: 40,
    },
    {
      field: 'glCode',
      title: 'GL Code',
      menu: false,
      component: GlCodeDropDown,
      width: '350px',
      minResizableWidth: 150,
    },
    {
      field: 'notes',
      title: 'Notes',
      component: GlCodesNotes,
      menu: false,
      width: '200px',
      minResizableWidth: 150,
    },
    {
      field: 'glSubTotal',
      title: 'GL Subtotal',
      menu: false,
      dataType: 'dollar',
      format: '{0:c2}',
      width: '150px',
      component: GlCodeSubTotal,
    },
    {
      field: 'taxableAmount',
      title: 'Taxable Amt',
      menu: false,
      dataType: 'dollar',
      format: '{0:c2}',
      width: '100px',
      component: GlCodeTaxableAmount,
    },
    {
      field: 'discountAmt',
      title: 'Discount',
      menu: false,
      dataType: 'dollar',
      format: '{0:c2}',
      width: '100px',
      component: GlCodesDiscount,
    },
    {
      field: 'shipCostAmt',
      title: 'Shipping',
      menu: false,
      dataType: 'dollar',
      format: '{0:c2}',
      width: '100px',
      component: GlCodesShipping,
    },
    {
      field: 'salesTaxAmt',
      title: 'Taxes',
      menu: false,
      dataType: 'dollar',
      format: '{0:c2}',
      width: '100px',
      component: GlCodesTaxes,
    },
    {
      field: 'glTotal',
      title: 'GL Total',
      menu: false,
      dataType: 'dollar',
      format: '{0:c2}',
      width: '100px',
      component: GlCodeTotal,
    },
    {
      field: 'action',
      title: 'Action',
      menu: false,
      component: GlCodeAction,
      width: '100px',
    },
  ],[isInvoiceMPA]);

  
  return invoiceDetailsGLCodesColumns;
};

export const invoiceDetailsGLCodeSubColumns: GridColumn<any>[] = [
  {
    field: 'errors',
    title: '',
    component: InvoiceBudgetPeriodWarning,
    menu: false,
    width: 40,
  },
  {
    field: 'accountingPeriod',
    title: 'Accounting Period',
    width: 200,
    menu: false,
    minResizableWidth: 150,
  },
  {
    field: 'percentageAmount',
    title: '% Distribution',
    format: '{0:n2}%',
    width: 150,
    menu: false,
    minResizableWidth: 150,
  },
  {
    field: 'glSubTotal',
    title: '',
    menu: false,
    dataType: 'dollar',
    format: '{0:c2}',
    width: 100,
  },
  {
    field: 'taxableAmount',
    title: '',
    menu: false,
    dataType: 'dollar',
    format: '{0:c2}',
    width: 100,
  },
  {
    field: 'discountAmt',
    title: '',
    menu: false,
    dataType: 'dollar',
    format: '{0:c2}',
    width: 100,
  },
  {
    field: 'shipCostAmt',
    title: '',
    menu: false,
    dataType: 'dollar',
    format: '{0:c2}',
    width: 100,
  },
  {
    field: 'salesTaxAmt',
    title: '',
    menu: false,
    dataType: 'dollar',
    format: '{0:c2}',
    width: 100,
  },
  {
    field: 'glTotal',
    title: '',
    menu: false,
    dataType: 'dollar',
    format: '{0:c2}',
    width: 100,
  },
  {
    field: '',
    title: '',
    menu: false,
    width:100,
  },
];